import AppConfigurationBPM from 'bpm/components/configuration/AppConfiguration'
import MainPageBPM from 'bpm/pages/MainPage'
import AppConfiguration from 'components/configuration/AppConfiguration'
import MainPage from 'pages/MainPage'
import React from 'react'
import ReactDOM from 'react-dom'
import * as serviceWorker from 'serviceWorkerRegistration'

ReactDOM.render(
    window?.location?.href?.includes('/bpm') ? (
        <AppConfigurationBPM>
            <MainPageBPM />
        </AppConfigurationBPM>
    ) : (
        <AppConfiguration>
            <MainPage />
        </AppConfiguration>
    ),
    document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register()
